import type { AudioBankLoader } from "./AudioBankLoader";
import type { GameAudioOverrides } from "./types";

/** The universal slot-UX sounds every title needs at the first gesture (an unregistered id is skipped with a dev log). */
const CRITICAL_SOUND_IDS = ["music_base", "ui_click", "spin_start", "spin_slam", "bet_increase", "bet_decrease", "bigwin_start", "bigwin_count_start", "bigwin_count_end", "bigwin_end"] as const;

/**
 * Preload the critical set — the base music, the game's ambient bed, the UI and spin cues, the
 * big-win stingers — plus the game's declared preloads (mechanic and feature sounds; de-duped by
 * the loader). Called at boot by `preloadSounds()` and again by the first unlock, which joins the
 * downloads still under way and fetches again any that were dropped (decision 21).
 */
export async function preloadCriticalSounds(loader: AudioBankLoader, overrides: GameAudioOverrides | null | undefined): Promise<void> {
  const ambientId = overrides?.ambientTrackId;
  await Promise.all([
    ...CRITICAL_SOUND_IDS.map((id) => loader.preloadOne(id)),
    ...(ambientId ? [loader.preloadOne(ambientId)] : []),
    ...(overrides?.preloadIds ?? []).map((id) => loader.preloadOne(id)),
  ]);
}
